const HOURS_REGEX = new RegExp(/^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$/);

export default HOURS_REGEX;
